export const environment = {
	development: true,
	production: false,
	apiBaseUrl: 'https://dpnf.test.dpworks.in/',
	waitingSeconds: 60,	
};
